import { Column, ColumnProps } from 'primereact/column'
import { DataTable, DataTableProps } from 'primereact/datatable'
import React from 'react'
import classes from './AddAttachmentsRPGrid.module.scss'

interface AddAttachmentsRPGridProps {
  dtProps?: DataTableProps
  columns?: ColumnProps[]
  gridContainerClassName?: string
}

const AddAttachmentsRPGrid = (props: AddAttachmentsRPGridProps) => {
  return (
    <div className={`${props.gridContainerClassName}`}>
      <DataTable
        dataKey="id"
        className={classes['add-attachments-rp-grid']}
        size="small"
        columnResizeMode="fit"
        responsiveLayout="scroll"
        scrollable
        scrollHeight="20rem"
        {...props.dtProps}
      >
        {props.dtProps?.rowExpansionTemplate && (
          <Column expander headerStyle={{ width: '3rem', paddingLeft: '3rem' }} />
        )}
        {props.dtProps?.selectionMode && (
          <Column
            selectionMode="multiple"
            style={{ maxWidth: '40px', flex: 'none' }}
            headerStyle={{ width: '40px' }}
          ></Column>
        )}

        {props.columns?.map((column, index) => {
          return <Column key={`${column.field}-${index}`} {...column} />
        })}
      </DataTable>
    </div>
  )
}

export default AddAttachmentsRPGrid
